import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { RegistrationService } from '../../../core/services/registration.service';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'otp-verification',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './onboarding-verify-otp.html',
  styleUrls: ['./onboarding-verify-otp.scss'],
})
export class OnboardingVerifyOtp implements OnInit {
  form!: FormGroup;
  errorMessage = signal<string | null>(null);
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private registrationService: RegistrationService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
    });
  }

  submitOtp(): void {
    if (this.form.invalid) return;

    this.isLoading = true;
    this.errorMessage.set(null);

    const otpCode = this.form.get('otp')?.value;
    const userId: string | null = this.route.snapshot.paramMap.get('userId');

    this.registrationService.verifyOtp(otpCode, userId).subscribe({
      next: (res) => {
        this.isLoading = false;
        // ✅ Navigate to dashboard or welcome page
        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.isLoading = false;
        this.notificationService.error(error.error.message);
        this.errorMessage.set(error?.error.message || 'Invalid OTP. Please try again.');
      },
    });
  }

  resendOtp(): void {
    this.isLoading = true;
    this.registrationService.resendOtp().subscribe({
      next: () => {
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.notificationService.error(error.message);
        this.errorMessage.set('Failed to resend OTP. Please try again.');
      },
    });
  }
}
